// @flow

import React, { useState } from 'react';
import { log } from '../../utils/jsUtils';
import { useStore } from '../../store';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import AddProperty from './AddPropertyDialog';
import HeaderTopBar from '../HeaderTopBar';
import SPBackend from '../../services/SPBackend';
import AppLoadingSpinner from '../SharedComponents/AppLoadingSpinner';

import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';

type Props = {
  mobileOpen: bool,
  usehandleDrawerToggle: Function,
  setProperties: Function
};


const PropertiesHeader = (props: Props) => {
  log('[PropertiesHeader] props: ', props);
  const {
    setProperties,
    usehandleDrawerToggle
  } = props;
  const theme = useTheme();
  const [openAddPropertyDialog, setOpenAddPropertyDialog] = useState(false);

  const [store, dispatch] = useStore();
  const {
    user,
    accountSettings,
    i18n
  } = store;

  const handleAddProperty = (address: string) => {
    log('[handleAddProperty] address, user: ', address, user);
    const newBuilding = {
      Property: address
    };
    SPBackend.createBuilding(newBuilding, user)
      .then((response) => {
        const {data: newBuilding} = response;
        log('[createBuilding] res: ', newBuilding);
        dispatch({
          type: 'ACTION_SET_ACCOUNT_SETTINGS',
          accountSettings: {
            ...accountSettings,
            SetupRequired: {
              ...accountSettings.SetupRequired,
              Properties: false
            }
          }
        });
        setProperties(prevState => {
          return [
            newBuilding,
            ...prevState
          ];
        });
      })
      .catch(error => {
        log('[handleAddProperty.createBuilding] error: ', error);
      });
  };

  return (
    <AppBar
      sx={memberHeaderStyles.appBar(theme)}
      position="fixed"
    >
      <Toolbar
        sx={memberHeaderStyles.toolbar(theme)}
        disableGutters
      >
        <Grid
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography
              sx={memberHeaderStyles.pageTitle(theme)}
              variant='h2'>{i18n.t('Properties')}</Typography>
          </HeaderTopBar>
          <Grid
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.bottomBar(theme)
            }}
            item
          >
            <Grid container>
              <Box
                sx={{
                  ...memberHeaderStyles.toggleContainer(theme),
                  ...memberHeaderStyles.dividerRight(theme)
                }}
              >
                <Tooltip
                  aria-label={`Add new ${i18n.t('property')}`}
                  title={`Add new ${i18n.t('property')}`}
                >
                  <Button
                    sx={memberHeaderStyles.navButton(theme)}
                    onClick={() => setOpenAddPropertyDialog(true)}
                  >
                    <i className={'icon-add'} />
                    <div>{i18n.t('Property')}</div>
                  </Button>
                </Tooltip>
              </Box>
              <Box sx={memberHeaderStyles.grow(theme)} />
            </Grid>
          </Grid>
          <AppLoadingSpinner />
        </Grid>
      </Toolbar>
      <AddProperty
        open={openAddPropertyDialog}
        setOpen={setOpenAddPropertyDialog}
        triggerAction={handleAddProperty}
      />
    </AppBar>
  );
};

export default PropertiesHeader;
